window.STBInit_sign = function(){
const bootRoot=document.getElementById("stbSign");
if(!bootRoot||bootRoot.dataset.shopifyBoot)return;
bootRoot.dataset.shopifyBoot="true";
(()=>{



const $=id=>document.getElementById(id), C=$("stbSign"), B=$("stbsBoard"), T1=$("stbsT1"), T2=$("stbsT2"), M=$("stbsMsg");

const sizes=[
 {name:"The First Due",key:"first due",h:8,w:24,price:149.99,sub:'8" × 24" • Small'},
 {name:"The Working Fire",key:"working fire",h:12,w:48,price:249.99,sub:'12" × 48" • Medium'},
 {name:"The General Alarm",key:"general alarm",h:16,w:72,price:379.99,sub:'16" × 72" • Large'},
 {name:"The Special Call",key:"special call",custom:true,price:null,sub:"Custom dimensions • Quote"}
];

const finishes=[
 ["Distressed Natural","#a77a4f"],["Dark Walnut","#52331f"],["Weathered Gray","#77736c"],
 ["Gloss Black","#111111"],["White Wash","#ded8ca"]
];

const colors=[
 ["Black","#111111"],["Ivory","#f4f0e8"],["Big Rock Lime","#d7ff00"],["Fire Red","#c71920"],
 ["Royal Blue","#154b9b"],["Gold","#d6aa36"],["Silver","#aeb4b8"],["Orange","#e66c21"]
];

const stripeColors=[
 ["Big Rock Lime","#d7ff00"],["Fire Red","#c71920"],["Thin Blue","#1476d4"],["White","#f4f0e8"],
 ["Gold","#d6aa36"],["Orange","#e66c21"],["Black","#111111"]
];

const fonts=[
 ["Firehouse Serif","'Roboto Slab',serif"],["Jersey Block","'Graduate',serif"],
 ["Condensed","'Oswald',sans-serif"],["Stencil","'Stardos Stencil',serif"],["Roman","'Cinzel',serif"]
];

const effects=[
 ["Solid","solid",""],["Thin Red Line","line","#ff2433"],["Thin Blue Line","line","#1688e8"],
 ["Thin Green Line","line","#17a65b"],["Thin Gold Line","line","#d6aa36"],
 ["Outline","outline",""],["Drop Shadow","shadow","#111111"]
];

const layouts=[
 ["No Stripes","none"],["Top + Bottom","topbottom"],["Double Top + Bottom","double"],
 ["Center Rail","center"],["Double Center Rail","centerdouble"],["Classic Border","border"],
 ["Double Firehouse Border","classic"]
];

let state={
 size:sizes[0],finish:"Distressed Natural",font:"Firehouse Serif",fontCss:fonts[0][1],
 letter:"Black",letterHex:"#111111",effect:"Solid",effectType:"solid",effectHex:"",
 layout:"Top + Bottom",layoutKey:"topbottom",stripe:"Big Rock Lime",stripeHex:"#d7ff00"
};

function money(n){return "$"+n.toFixed(2)}
function currentDims(){
 if(!state.size.custom)return [state.size.h,state.size.w];
 const h=Math.max(8,Math.min(24,parseInt($("stbsCH").value)||12));
 const w=Math.max(18,Math.min(96,parseInt($("stbsCW").value)||48));
 return [h,w];
}
function setOn(box,btn){box.querySelectorAll("button").forEach(b=>b.classList.remove("on"));btn.classList.add("on")}

function buildSizes(){
 const box=$("stbsSizes");
 box.innerHTML=sizes.map((s,i)=>`<button type="button" class="stbs-size ${s===state.size?"on":""}" data-i="${i}">
 <strong>${s.name}</strong><small>${s.sub}${!s.custom&&signVariant(s)?" • "+STBCommerce.money(signVariant(s).price):""}</small></button>`).join("");
 box.querySelectorAll("button").forEach(btn=>btn.onclick=()=>{
   setOn(box,btn);state.size=sizes[+btn.dataset.i];
   $("stbsCustomDims").classList.toggle("show",!!state.size.custom);update();
 });
}

function buildSwatches(id,list,def,cb){
 const box=$(id);
 box.innerHTML=list.map(([n,c])=>`<div class="stbs-sw"><button type="button" data-n="${n}" data-c="${c}" style="background:${c}"></button><small>${n}</small></div>`).join("");
 box.querySelectorAll("button").forEach(btn=>{
   if(btn.dataset.n===def)btn.classList.add("on");
   btn.onclick=()=>{setOn(box,btn);cb(btn.dataset.n,btn.dataset.c);update()}
 });
}
function buildPills(id,list,def,cb){
 const box=$(id);
 box.innerHTML=list.map((x,i)=>`<button type="button" class="stbs-pill ${x[0]===def?"on":""}" data-i="${i}"><strong>${x[0]}</strong></button>`).join("");
 box.querySelectorAll("button").forEach(btn=>btn.onclick=()=>{setOn(box,btn);cb(list[+btn.dataset.i]);update()});
}

function effectClass(el){
 el.classList.remove("fx-solid","fx-line","fx-outline","fx-shadow");
 el.classList.add("fx-"+state.effectType);
}

function update(){
 T1.value=T1.value.toUpperCase().slice(0,22);
 T2.value=T2.value.toUpperCase().slice(0,26);
 const l1=T1.value.trim()||"YOUR TEXT";
 const l2=T2.value.trim();

 $("stbsLine1").textContent=l1;
 $("stbsLine2").textContent=l2||"";
 $("stbsLine1").classList.toggle("ph",!T1.value.trim());
 $("stbsLine2").style.display=l2?"block":"none";

 B.dataset.finish=state.finish;
 B.className="layout-"+state.layoutKey;
 C.style.setProperty("--letter",state.letterHex);
 C.style.setProperty("--stripe",state.stripeHex);
 C.style.setProperty("--effect",state.effectHex||state.letterHex);

 ["stbsLine1","stbsLine2"].forEach(id=>{
   const e=$(id);e.style.fontFamily=state.fontCss;effectClass(e);
 });

 const [h,w]=currentDims();
 B.style.aspectRatio=w+"/"+h;
 $("stbsDimA").textContent=h+'" Tall';
 $("stbsDimB").textContent=w+'" Wide';

 $("sumSize").textContent=state.size.name;
 $("sumDims").textContent=h+'" × '+w+'"';
 $("sumT1").textContent=l1;
 $("sumT2").textContent=l2||"None";
 $("sumFinish").textContent=state.finish;
 $("sumFont").textContent=state.font;
 $("sumLetter").textContent=state.letter;
 $("sumEffect").textContent=state.effect;
 $("sumLayout").textContent=state.layout;
 $("sumStripe").textContent=state.stripe;


 const p=$("stbsPrice"),add=$("stbsAdd");
 if(state.size.custom){p.textContent="QUOTE";add.disabled=false;add.textContent="REQUEST CUSTOM-SIZE QUOTE";}
 else STBCommerce.priceState(add,p,signVariant(state.size));

}

function buildSheet(){
 const [h,w]=currentDims();
 return `${state.size.name} | ${h}x${w} | Line 1: ${T1.value.trim()||"NONE"} | Line 2: ${T2.value.trim()||"NONE"} | Background: ${state.finish} | Font: ${state.font} | Letter Color: ${state.letter} | Letter Effect: ${state.effect} | Stripe Layout: ${state.layout} | Stripe Color: ${state.stripe} | Finish: Epoxy Wet-Bar Gloss`;
}

function productSlug(){
 const m=location.pathname.match(/\/products\/([^/?#]+)/i);
 return m?m[1]:"";
}

function findVariant(prod,key){
 const variants=prod.variants||[];
 return variants.find(v=>JSON.stringify(v).toLowerCase().includes(key))||null;
}


function signVariant(size){
 const i=sizes.indexOf(size),alias=['Small','Medium','Large'][i];
 return STBCommerce.matchVariant({'Size|Sign Size':[size.name,size.key,alias]});
}
$("stbsAdd").onclick=async()=>{
 if(!T1.value.trim()){M.textContent="Enter your main lettering first.";T1.focus();return;}
 const [h,w]=currentDims();
 if(state.size.custom){
  const rawH=Number($("stbsCH").value),rawW=Number($("stbsCW").value);
  if(!Number.isInteger(rawH)||rawH<8||rawH>24||!Number.isInteger(rawW)||rawW<18||rawW>96){M.textContent="Enter whole-inch dimensions: height from 8–24 inches and width from 18–96 inches.";return;}
  STBCommerce.requestQuote(buildSheet());return;
 }
 const btn=$("stbsAdd");btn.disabled=true;btn.textContent="ADDING...";M.textContent="";
 const properties={"Build":state.size.name,"Dimensions":`${h}\" H × ${w}\" W`,"Line 1":T1.value.trim(),"Line 2":T2.value.trim()||"None","Background Finish":state.finish,"Font":state.font,"Letter Color":state.letter,"Letter Effect":state.effect,"Stripe Layout":state.layout,"Stripe Color":state.stripe,"Clear Finish":"Epoxy Wet-Bar Gloss"};
 try{await STBCommerce.add(signVariant(state.size),properties,btn);}
 catch(error){M.textContent=error.message;update();}
};

$("stbsReset").onclick=()=>{
 T1.value="ENGINE 1502";T2.value="BIG ROCK FIRE";
 state={size:sizes[0],finish:"Distressed Natural",font:"Firehouse Serif",fontCss:fonts[0][1],
 letter:"Black",letterHex:"#111111",effect:"Solid",effectType:"solid",effectHex:"",
 layout:"Top + Bottom",layoutKey:"topbottom",stripe:"Big Rock Lime",stripeHex:"#d7ff00"};
 $("stbsCH").value="";$("stbsCW").value="";
 buildAll();update();M.textContent="";
};

function buildAll(){
 buildSizes();
 buildSwatches("stbsFinishes",finishes,state.finish,(n)=>state.finish=n);
 buildPills("stbsFonts",fonts,state.font,x=>{state.font=x[0];state.fontCss=x[1]});
 buildSwatches("stbsLetters",colors,state.letter,(n,c)=>{state.letter=n;state.letterHex=c});
 buildPills("stbsEffects",effects,state.effect,x=>{state.effect=x[0];state.effectType=x[1];state.effectHex=x[2]});
 buildPills("stbsLayouts",layouts,state.layout,x=>{state.layout=x[0];state.layoutKey=x[1]});
 buildSwatches("stbsStripes",stripeColors,state.stripe,(n,c)=>{state.stripe=n;state.stripeHex=c});
 $("stbsCustomDims").classList.toggle("show",!!state.size.custom);
}
[T1,T2,$("stbsCH"),$("stbsCW")].forEach(el=>el.addEventListener("input",update));

const current=STBCommerce.selectedVariant();
const initial=sizes.find(s=>!s.custom&&signVariant(s)?.id===current?.id);
if(initial)state.size=initial;
buildAll();update();
})();
};
if(document.readyState!=="loading")window.STBInit_sign();
else document.addEventListener("DOMContentLoaded",window.STBInit_sign, {once:true});
